import React, { useEffect, useState, useRef } from 'react'
import {
    Box,
    Select,
    Stack,
    Input,
    HStack,
    IconButton,
    Spinner,
    Center,
    Text,
    Alert,
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    Icon,
    Collapse,
    Button,
    useToast,
    Table,
        Thead,
        Tr,
        Th,
        Tbody,
        Td,
        Image,
        VStack,
} from '@chakra-ui/react'
import {
    Pagination,
    usePagination,
    PaginationNext,
    PaginationPage,
    PaginationPrevious,
    PaginationContainer,
    PaginationPageGroup,
    PaginationSeparator,
} from '@ajna/pagination'
import AdminBlockCard from '../../components/AdminBlockCard'
import AdminBreadcrumb from '../../components/AdminBreadcrumb'
import AdminIndustryCard from '../../components/AdminIndustryCard'
import { GoSearch, GoPlus } from 'react-icons/go'
import { deleteRequest, getRequest, postRequest } from '../../services/base.service'
import { IoIosArrowBack } from 'react-icons/io'
import { IoIosArrowForward } from 'react-icons/io'
import { FiFilter, FiEdit2, FiDelete } from 'react-icons/fi'
import { useDispatch } from 'react-redux'
import {
    setAdminSidebarFalseOnUrlChange,
    setCurrentPageHeading,
} from '../../redux/common/commonActions'
import { Select as SearchableSelect} from 'chakra-react-select'
import { useNavigate } from 'react-router-dom'
import SearchBox from '../../components/SearchBox'
import { Link } from 'react-router-dom';
import { MdDeleteForever } from "react-icons/md";

const breadCrumb = [
    { label: 'Dashboard', isCurrentPage: false, link: '/admin/dashboard' },
    { label: 'Industry List', isCurrentPage: true },
]

const IndustryList = () => {

    const [industryList, setIndustryList] = useState(null)
        const [deleteableIndustryId, setDeleteableIndustryId] = useState(null)
        const [showMobileActions, setShowMobileActions] = useState(false)
        const [paginationProperty, setPaginationProperty] = useState({
            total: 1,
            currentPage: 1,
            pageSize: 1,
        })
        const [spinner, setSpinner] = useState({ status: true })
        const [queryParams, setQueryParams] = useState({
            // sort: '',
        })
        const [alertDialogIsOpen, setAlertDialogIsOpen] = useState(false)
    //     const [countryList, setCountryList] = useState([])
    //     const [stateList, setStateList] = useState([])
    //     const [selectedCountry, setSelectedCountry] = useState(null)
     const navigate = useNavigate()

    const {
            pages,
            pagesCount,
            currentPage,
            setCurrentPage,
            isDisabled,
            setPageSize,
        } = usePagination({
            total: paginationProperty.total,
            limits: {
                outer: 2,
                inner: 2,
            },
            initialState: {
                pageSize: paginationProperty.pageSize,
                isDisabled: false,
                currentPage: 1,
            },
        })

    const dispatch = useDispatch()
    const toast = useToast()

    useEffect(() => {
            dispatch(setCurrentPageHeading('Industry List'))
            dispatch(setAdminSidebarFalseOnUrlChange())
    }, [])

    useEffect(() => {
            fetchIndustryList({ page: currentPage })
            // fetchCountryList()
    }, [currentPage])
    
    // useEffect(() => {
    //         if (selectedCountry) {
    //             fetchStateList();
    //         }
    // }, [selectedCountry])

    const fetchIndustryList = (params = {}) => {
            setSpinner({ status: true })
            getRequest('admin/industries', { params })
                .then((res) => {
                    console.log('INDUSTRY LIST: ', res.data)
                    setIndustryList(res.data)
                    setPaginationProperty({
                        total: res.meta.total,
                        currentPage: res.meta.current_page,
                        pageSize: res.meta.per_page,
                    })
                    setPageSize(res.meta.per_page)
                    setSpinner({ status: false })
                })
                .catch((err) => {
                    console.log('ERR: ', err)
                })
    }

    const handlePageChange = (nextPage) => {
		setCurrentPage(nextPage)
	}

    const deleteIndustry = (industryId) => {
		setDeleteableIndustryId(industryId)
		setAlertDialogIsOpen(true)
	}

	const hideConfirmDialog = () => {
		setDeleteableIndustryId(null)
		setAlertDialogIsOpen(false)
	}

    const handleIndustryDeleteConfirm = () => {
            deleteRequest(`admin/industries/${deleteableIndustryId}`)
                .then((res) => {
                    
                    hideConfirmDialog()
                    toast({
                        title: 'Deleted',
                        description: res.message,
                        status: 'success',
                        duration: 5000,
                        isClosable: true,
                    })
                    setCurrentPage(1)
                    fetchIndustryList({ ...queryParams, page: 1 })

                })
                .catch((error) => {
                    toast({
                        title: 'Error',
                        description: error.response.data.message || 'Something went wrong',
                        status: 'error',
                        duration: 5000,
                        isClosable: true,
                    })
                    
                })
    }

    const cancelRef = useRef()

    const handleSearch = (e) => {
		e.preventDefault()
		setCurrentPage(1)
		fetchIndustryList({ ...queryParams, page: 1 })
	}
    const handleReset = () => {
		const defaultQuery = { keyword: '' }
		setQueryParams(defaultQuery)
		setCurrentPage(1)
		fetchIndustryList({ ...defaultQuery, page: 1 })
	}

    return (
            <>
                <AdminBreadcrumb items={breadCrumb} />
                <SearchBox
					primaryActions={
						<>
							<HStack as={'form'} w="100%">
							    <Input
									placeholder="Search..."
									w={['100%']} 
									size={'md'}
									borderColor={'gray.300'}
									rounded={'md'}
                                    value={queryParams.keyword || ''}
									onChange={(e) => {
									    setQueryParams({
											...queryParams,
											    keyword: e.target.value,
												})
											}}
										/>
										{/* <Box>
											<IconButton
												aria-label="Search"
												size={'md'}
												icon={<GoSearch />}
												variant={'brand'}
												type="submit"
												onClick={handleSearch}
											/>
										</Box> */}
							</HStack>
						</>
					}
					secondaryActions={
						<VStack as="form" spacing={4} w="100%" align="stretch">
							<HStack justify="flex-end" spacing={4}>
							<Button 
                                variant="outline"
                                colorScheme="gray" 
                                size="md"				
                                rounded={'md'}
                                onClick={handleReset}
                            >
								Reset
							</Button>
                            <Button 
								variant={'brand'}
								size="md"
								rounded={'md'}
								type="submit" 
                                onClick={handleSearch}
                            >
								Search
							</Button>
							</HStack>
						</VStack>
					}>
			    </SearchBox>
                <Box py={'7'}>
                    <AlertDialog
                                    isOpen={alertDialogIsOpen}
                                    leastDestructiveRef={cancelRef}
                                    onClose={hideConfirmDialog}
                    >
                                    <AlertDialogOverlay>
                                        <AlertDialogContent>
                                            <AlertDialogHeader fontSize="lg" fontWeight="bold">
                                                Confirmation
                                            </AlertDialogHeader>
                
                                            <AlertDialogBody>
                                                Are you sure? You can't undo this action afterwards.
                                            </AlertDialogBody>
                
                                            <AlertDialogFooter>
                                                <Button ref={cancelRef} onClick={hideConfirmDialog}>
                                                    Cancel
                                                </Button>
                                                <Button
                                                    colorScheme={'red'}
                                                    onClick={() => handleIndustryDeleteConfirm()}
                                                    ml={3}
                                                >
                                                    Confirm
                                                </Button>
                                            </AlertDialogFooter>
                                        </AlertDialogContent>
                                    </AlertDialogOverlay>
                    </AlertDialog>
                    <AdminBlockCard
                        title={'Industry List'}
                        // primaryActions={
                        //     <>
                        //         {/* <HStack> */}
                        //             {/* <HStack as={'form'}> */}
                        //                 <Input
                        //                     placeholder="Search..."
                        //                     w={['100%', '100%', '100%', '850px']}
                        //                     size={'sm'}
                        //                     borderColor={'gray.300'}
                        //                     onChange={(e) => {
                        //                         setQueryParams({
                        //                             ...queryParams,
                        //                             keyword: e.target.value,
                        //                         })
                        //                     }}
                        //                 />
                        //                 {/* <Box> */}
                        //                     <IconButton
                        //                         aria-label="Search"
                        //                         size={'sm'}
                        //                         icon={<GoSearch />}
                        //                         variant={'brand'}
                        //                         type="submit"
                        //                         onClick={handleSearch}
                        //                     />
                        //                 {/* </Box>
                        //             </HStack> */}
                        //             {/* <Icon
                        //                 as={FiFilter}
                        //                 display={[
                        //                     'inline-block',
                        //                     'inline-block',
                        //                     'inline-block',
                        //                     'none',
                        //                 ]}
                        //                 onClick={() => {
                        //                     setShowMobileActions(!showMobileActions)
                        //                 }}
                        //                 _hover={{ cursor: 'pointer' }}
                        //             /> */}
                        //             {/* <Box>
                        //                     <Button
                        //                         // colorScheme={'red'}
                        //                         variant={'brand'}
                        //                         size={'sm'}
                        //                         onClick={() => navigate('/admin/industry/create')}
                        //                     >
                        //                         <Icon as={GoPlus} mr={2} />
                        //                         ADD INDUSTRY
                        //                     </Button>
                        //             </Box> */}
                        //         {/* </HStack> */}
                        //     </>
                        // }
                        secondaryActions={
                            // <Box>
                                            <Button
                                                // colorScheme={'red'}
                                                variant={'brand'}
                                                size={'sm'}
                                                onClick={() => navigate('/admin/industry/create')}
                                            >
                                                <Icon as={GoPlus} mr={2} />
                                                ADD INDUSTRY
                                            </Button>
                            // </Box>
                        }
                        // mobileActions={
                        //     <Collapse
                        //         in={showMobileActions}
                        //         unmountOnExit={true}
                        //         animateOpacity
                        //     >
                        //         <HStack
                        //             display={[
                        //                 `${showMobileActions ? 'flex' : 'none'}`,
                        //                 `${showMobileActions ? 'flex' : 'none'}`,
                        //                 `${showMobileActions ? 'flex' : 'none'}`,
                        //                 'none',
                        //             ]}
                        //             transition={'2s'}
                        //             direction="column"
                        //         >
                        //             {/* <Select
                        //                 placeholder="Country"
                        //                 size="sm"
                        //                 borderColor="gray.300"
                        //                 value={queryParams?.country}
                        //                 onChange={(e) => handleChange('country_id', e)}
                        //             >
                        //                 {countryList.length > 0 &&
                        //                     countryList.map((country) => (
                        //                         <option key={country.id} value={country.id}>
                        //                             {country.name}
                        //                         </option>
                        //                 ))}
                        //             </Select>
                        //             <Select
                        //                 placeholder="State"
                        //                 size="sm"
                        //                 borderColor="gray.300"
                        //                 value={queryParams?.state}
                        //                 onChange={(e) => handleChange('state_id', e)}
                        //             >
                        //                 {stateList.length > 0 &&
                        //                     stateList.map((state) => (
                        //                         <option key={state.id} value={state.id}>
                        //                             {state.name}
                        //                         </option>
                        //                 ))}
                        //             </Select>
                        //             <Input
                        //                 placeholder="Enter Area"
                        //                 size="sm"
                        //                 borderColor="gray.300"
                        //                 value={queryParams?.address_keyword || ''}
                        //                 onChange={(e) => {
                        //                     setQueryParams({
                        //                         ...queryParams,
                        //                         address_keyword: e.target.value,
                        //                     })
                        //                 }}
                        //             />
                        //             <Select
                        //                 placeholder="Status"
                        //                 size={'sm'}
                        //                 borderColor={'gray.300'}
                        //                 value={queryParams?.status}
                        //                 onChange={(e) => handleChange('status', e)}
                        //             >
                        //                 <option value={'pending'}>Pending</option>
                        //                 <option value={'approved'}>Approved</option>
                        //                 <option value={'declined'}>Declined</option>
                        //                 <option value={'blocked'}>Blocked</option>
                        //             </Select>
                        //             <Select
                        //                 placeholder="Sort By"
                        //                 size={'sm'}
                        //                 borderColor={'gray.300'}
                        //                 value={queryParams?.sort}
                        //                 onChange={(e) => handleChange('sort', e)}
                        //             >
                        //                 <option value={'desc'}>New</option>
                        //                 <option value={'asc'}>Older</option>
                        //             </Select> */}
                        //         </HStack>
                        //     </Collapse>
                        // }
                    >
                        {spinner.status ? (
                            <Center>
                                <Spinner color="red.500" size="xl" speed="0.6s" />
                            </Center>
                        ) : industryList.length > 0 ? (
                            <>
                                <Stack gap={2} rounded={'md'} overflow={'auto'} border={'1px'} borderColor="gray.200">
                                    {/* {industryList?.map((industry, index) => (
                                        <AdminIndustryCard
                                            key={index}
                                            industryName={industry?.name}
                                            data={industry}
                                            onDelete={deleteIndustry}
                                        />
                                    ))} */}
                                <Table
                                    variant="simple"
                                    w={'100%'}
                                >
                                    <Thead bg="gray.100">
                                        <Tr>
                                            <Th>Image</Th>
                                            <Th>Id</Th>
                                            <Th>Name</Th>
                                            <Th>Created</Th>
                                            <Th textAlign="right">Actions</Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        {industryList.map((industry, index) => (
                                            <Tr key={industry.id} bg={index % 2 === 0 ? 'gray.50' : 'white'}>
                                                <Td>
                                                    <Image
                                                        src={industry.image}
                                                        alt={industry.name}
                                                        boxSize="50px"
                                                        objectFit="contain"
                                                    />
                                                </Td>
                                                <Td>{industry.id}</Td>
                                                <Td>{industry.name}</Td>
                                                <Td>{industry.created_at}</Td>
                                                <Td key={industry.id}>
                                                    <HStack
                                                        textAlign="right"
                                                        align="right"
                                                        justify="right"
                                                        gap={2}
                                                    >
                                                        <Link to={`/admin/industry/edit/${industry?.id}`}>
                                                            <FiEdit2 cursor="pointer" />
                                                        </Link>
                                                        <MdDeleteForever
                                                            size={21}
                                                            cursor="pointer"
                                                            onClick={() => deleteIndustry(industry.id)}
                                                        />
                                                    </HStack>
                                                </Td>												
                                            </Tr>
                                        ))}
                                    </Tbody>									
                                </Table>                                    
                                </Stack>
                                <Pagination
                                    pagesCount={pagesCount}
                                    currentPage={currentPage}
                                    isDisabled={isDisabled}
                                    onPageChange={handlePageChange}
                                >
                                    <PaginationContainer align="center" justify="center" p={4}>
                                        <PaginationPrevious
                                            px={'2'}
                                            _hover={{
                                                bg: 'gray.100',
                                            }}
                                            bg="white"
                                            color="gray.700"
                                            _disable={{ bg: 'white' }}
                                        >
                                            <Text>
                                                <IoIosArrowBack />
                                            </Text>
                                        </PaginationPrevious>
                                        <PaginationPageGroup
                                            isInline
                                            align={'center'}
                                            mx={'1'}
                                            separator={
                                                <PaginationSeparator fontSize="sm" w={7} jumpSize={11} />
                                            }
                                        >
                                            {pages.map((page) => (
                                                <PaginationPage
                                                    w={7}
                                                    h={7}
                                                    bg={'gray.200'}
                                                    border={'1px'}
                                                    borderColor={'gray.300'}
                                                    key={`pagination_page_${page}`}
                                                    page={page}
                                                    color={'black.500'}
                                                    fontSize={'sm'}
                                                    _hover={{
                                                        bg: 'brand.600',
                                                        color: 'white',
                                                    }}
                                                    _current={{
                                                        bg: 'brand.500',
                                                        fontSize: 'sm',
                                                        color: 'white',
                                                        borderColor: 'brand.500',
                                                    }}
                                                />
                                            ))}
                                        </PaginationPageGroup>
                                        <PaginationNext
                                            w={7}
                                            h={7}
                                            _hover={{
                                                bg: 'gray.100',
                                            }}
                                            bg="white"
                                            color="gray.700"
                                            _disable={{ bg: 'white' }}
                                        >
                                            <Text>
                                                <IoIosArrowForward />
                                            </Text>
                                        </PaginationNext>
                                    </PaginationContainer>
                                </Pagination>
                            </>
                        ) : (
                            <Alert status="error">
                                <Center h={'100%'} w={'100%'}>
                                    NO DATA FOUND.
                                </Center>
                            </Alert>
                        )}
                    </AdminBlockCard>
                </Box>
            </>
    )

}

export default IndustryList